// Client-side mirror of the admin password policy enforced server-side by
// boompay-api (INF-231). This is for inline UX feedback ONLY — the server is
// the sole source of truth and still returns 422 on any policy violation.
//
// Locked policy: minimum 12 characters, at least one uppercase letter, one
// lowercase letter, and one digit. `new_password` must also differ from
// `current_password` (checked in the form, not here).

const PASSWORD_MIN_LENGTH = 12;

const passwordPolicyRules = [
  (password) => password.length >= PASSWORD_MIN_LENGTH,
  (password) => /[A-Z]/.test(password),
  (password) => /[a-z]/.test(password),
  (password) => /\d/.test(password)
];

export function passwordMeetsPolicy(password) {
  return passwordPolicyRules.every((rule) => rule(password));
}

export const PASSWORD_POLICY_HINT =
  "Must be at least 12 characters and include an uppercase letter, " +
  "a lowercase letter, and a number.";
